import { render, staticRenderFns } from "./NewAttendance.vue?vue&type=template&id=3df526d7&scoped=true"
import script from "./NewAttendance.vue?vue&type=script&lang=js"
export * from "./NewAttendance.vue?vue&type=script&lang=js"
import style0 from "./NewAttendance.vue?vue&type=style&index=0&id=3df526d7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df526d7",
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip});
